<template>
  <CModal :show.sync="showModal" title="Confirmar programacion" color="dark" size="lg" class="basic-modal-color">
    <CRow>
      <CCol md="12">
        <div class="summary-box mb-3">
          <p class="mb-1"><strong>Tipo:</strong> {{ summary.typeLabel }}</p>
          <p class="mb-1"><strong>Fecha/Hora:</strong> {{ summary.dateTime }}</p>
          <p class="mb-0"><strong>Total destinatarios:</strong> {{ recipients.length }}</p>
        </div>
      </CCol>

      <CCol md="12">
        <p class="mb-2"><strong>Destinatarios</strong></p>

        <div class="recipients-list">
          <table class="table table-sm table-bordered mb-0">
            <thead>
              <tr>
                <th style="width: 60px;">#</th>
                <th>Nombre</th>
                <th style="width: 180px;">Telefono</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(recipient, idx) in recipients" :key="recipient.id || idx">
                <td class="text-center">{{ idx + 1 }}</td>
                <td>{{ recipient.label }}</td>
                <td class="text-center">{{ recipient.phone || '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </CCol>
    </CRow>

    <template #footer>
      <CButton color="secondary" @click="showModal = false">Cancelar</CButton>
      <CButton color="dark" @click="confirm">Aceptar</CButton>
    </template>
  </CModal>
</template>

<script>
export default {
  name: 'ScheduledSendConfirmModal',
  data() {
    return {
      showModal: false,
      summary: {
        typeLabel: '-',
        dateTime: '-'
      },
      recipients: []
    }
  },
  methods: {
    show({ summary, recipients }) {
      this.summary = summary || { typeLabel: '-', dateTime: '-' }
      this.recipients = Array.isArray(recipients) ? recipients : []
      this.showModal = true
    },
    confirm() {
      this.showModal = false
      this.$emit('confirm')
    }
  }
}
</script>

<style scoped>
.summary-box {
  background: #f4f6f9;
  border: 1px solid #d8dee6;
  border-radius: 6px;
  padding: 10px 12px;
}

.recipients-list {
  max-height: 280px;
  overflow: auto;
}
</style>